(() => {
  if (window.__hoaNatalFormInit) return;
  window.__hoaNatalFormInit = true;

  const name  = document.querySelector("#hoa_name");
  const date  = document.querySelector("#hoa_birthdate"); // YYYY-MM-DD
  const place = document.querySelector("#hoa_birthplace");
  const time  = document.querySelector("#hoa_birthtime"); // HH:MM text
  const unk   = document.querySelector("#hoa_time_unknown");
  const notes = document.querySelector("#hoa_notes");

  if (!name || !date || !place) return;

  const form =
    document.querySelector("form[data-type='add-to-cart-form']") ||
    document.querySelector("product-form form") ||
    document.querySelector("form[action*='/cart/add']");

  if (!form) return;

  const pf = document.querySelector("product-form");
  const errorWrap = pf?.querySelector(".product-form__error-message-wrapper");
  const errorMsg  = pf?.querySelector(".product-form__error-message");
  const customError = document.querySelector("#hoa_form_error");
  const dynWrap = document.querySelector(".shopify-payment-button");

  const showError = (text) => {
    if (customError) {
      customError.textContent = text;
      customError.hidden = false;
    }

    if (errorWrap && errorMsg) {
      errorMsg.textContent = text;
      errorWrap.hidden = false;
    } else if (!customError) {
      alert(text);
    }
  };

  const clearError = () => {
    if (customError) {
      customError.hidden = true;
      customError.textContent = "";
    }

    if (errorWrap) errorWrap.hidden = true;
    if (errorMsg) errorMsg.textContent = "";
  };

  const clearInvalid = () => {
    [name, date, place, time].filter(Boolean).forEach(el => el.classList.remove("hoa-invalid"));
  };

  const focusField = (el) => {
    if (!el) return;
    el.classList.add("hoa-invalid");
    try { el.scrollIntoView({ behavior: "smooth", block: "center" }); } catch (e) {}
    setTimeout(() => {
      try { el.focus({ preventScroll: true }); }
      catch (e) { try { el.focus(); } catch (_) {} }
    }, 50);
  };

  const validName = (v) => {
    const s = (v || "").trim();
    if (s.length < 2) return false;
    return /^[\p{L}\s\-'.]+$/u.test(s);
  };

  const validPlace = (v) => {
    const s = (v || "").trim();
    if (s.length < 2) return false;
    return /^[\p{L}\s,\-'.]+$/u.test(s);
  };

  const validDate = (v) => {
    const s = (v || "").trim();
    if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return false;

    const [yyyy, mm, dd] = s.split("-").map(Number);
    const d = new Date(yyyy, mm - 1, dd);

    if (
      d.getFullYear() !== yyyy ||
      d.getMonth() !== (mm - 1) ||
      d.getDate() !== dd
    ) return false;

    const min = new Date(1940, 0, 1);
    const max = new Date();
    max.setHours(0, 0, 0, 0);
    d.setHours(0, 0, 0, 0);

    return d >= min && d <= max;
  };

  const validTime = (v) =>
    /^([01]\d|2[0-3]):([0-5]\d)$/.test((v || "").trim());

  const sanitizeNotes = (v) => (v ?? "").toString().replace(/[<>]/g, "");

  const formatTimeInput = () => {
    if (!time) return;
    if (unk && unk.checked) return;

    let s = time.value.replace(/[^\d]/g, "").slice(0, 4);
    if (s.length >= 3) time.value = `${s.slice(0, 2)}:${s.slice(2)}`;
    else time.value = s;
  };

  const getHiddenTimeStatus = () =>
    form.querySelector('input[name="properties[Час на раждане - статус]"]');

  const syncUnknownTime = () => {
    if (!time || !unk) return;

    if (unk.checked) {
      time.value = "";
      time.disabled = true;

      let hidden = getHiddenTimeStatus();
      if (!hidden) {
        hidden = document.createElement("input");
        hidden.type = "hidden";
        hidden.name = "properties[Час на раждане - статус]";
        form.appendChild(hidden);
      }
      hidden.value = "не знам";
    } else {
      time.disabled = false;
      const hidden = getHiddenTimeStatus();
      if (hidden) hidden.remove();
    }
  };

  const getValidationResult = () => {
    const n = name.value.trim();
    const d = date.value.trim();
    const p = place.value.trim();
    const t = time ? time.value.trim() : "";

    if (!n) return { ok: false, el: name, message: "Попълнете 'Име'." };
    if (!validName(n)) return { ok: false, el: name, message: "Името трябва да е текст (букви/интервали)." };

    if (!d) return { ok: false, el: date, message: "Изберете 'Дата на раждане' от календара." };
    if (!validDate(d)) return { ok: false, el: date, message: "Невалидна дата. Изберете валидна дата (1940–днес)." };

    if (!p) return { ok: false, el: place, message: "Попълнете 'Място на раждане'." };
    if (!validPlace(p)) return { ok: false, el: place, message: "Мястото трябва да е текст (пример: София, България)." };

    if (time && (!unk || !unk.checked)) {
      if (!t) return { ok: false, el: time, message: "Попълнете 'Час на раждане' или чекнете „Не знам часа“." };
      if (!validTime(t)) return { ok: false, el: time, message: "Часът трябва да е валиден (HH:MM), пример: 08:30." };
    }

    return { ok: true };
  };

  const validateDetailed = () => {
    clearInvalid();
    return getValidationResult();
  };

  const validate = () => getValidationResult().ok;
  window.__hoaNatalValidate = validate;

  const isCartAddUrl = (url) => typeof url === "string" && url.includes("/cart/add");

  if (!window.__hoaFetchPatched) {
    window.__hoaFetchPatched = true;

    const _fetch = window.fetch.bind(window);
    window.fetch = function(input, init) {
      const url = typeof input === "string" ? input : (input && input.url) || "";
      if (isCartAddUrl(url) && !validate()) {
        return Promise.reject(new Error("HOA natal form validation failed"));
      }
      return _fetch(input, init);
    };
  }

  if (!window.__hoaXHRPatched) {
    window.__hoaXHRPatched = true;

    const _open = XMLHttpRequest.prototype.open;
    const _send = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function(method, url) {
      this.__hoa_url = url || "";
      return _open.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function(body) {
      if (isCartAddUrl(this.__hoa_url || "") && !validate()) {
        try { this.abort(); } catch (e) {}
        return;
      }
      return _send.apply(this, arguments);
    };
  }

  const lockUI = () => {
    const ok = getValidationResult().ok;

    form.querySelectorAll(
      'button[name="add"], button[type="submit"][name="add"], .product-form__submit'
    ).forEach(btn => {
      btn.classList.toggle("hoa-locked", !ok);
      btn.setAttribute("aria-disabled", (!ok).toString());
      btn.dataset.hoaLocked = ok ? "0" : "1";
    });

    if (dynWrap) {
      dynWrap.classList.toggle("hoa-locked", !ok);
      dynWrap.dataset.hoaLocked = ok ? "0" : "1";
      dynWrap.style.pointerEvents = ok ? "auto" : "none";
      dynWrap.style.opacity = ok ? "" : "0.60";
    }
  };

  const blockIfInvalid = (e) => {
    clearError();
    clearInvalid();

    const r = getValidationResult();

    if (r.ok) {
      if (notes) notes.value = sanitizeNotes(notes.value);
      return true;
    }

    if (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }

    showError(r.message || "Моля, попълни задължителните полета.");
    if (r.el) focusField(r.el);
    return false;
  };

  const guardClick = (e) => {
    const btn = e.currentTarget;
    if (btn.dataset.hoaLocked === "1") {
      return blockIfInvalid(e);
    }
  };

  const dynGuard = (e) => {
    if (!dynWrap || dynWrap.dataset.hoaLocked !== "1") return;
    return blockIfInvalid(e);
  };

  const bindGuards = () => {
    form.querySelectorAll(
      'button[name="add"], button[type="submit"][name="add"], .product-form__submit'
    ).forEach(btn => {
      if (btn.dataset.hoaGuardBound === "1") return;
      btn.dataset.hoaGuardBound = "1";
      btn.addEventListener("click", guardClick, true);
    });

    if (!form.dataset.hoaSubmitBound) {
      form.dataset.hoaSubmitBound = "1";
      form.addEventListener("submit", (e) => {
        blockIfInvalid(e);
      }, true);
    }

    if (dynWrap && !dynWrap.dataset.hoaGuardBound) {
      dynWrap.dataset.hoaGuardBound = "1";
      dynWrap.addEventListener("click", dynGuard, true);
    }
  };

  const killSticky = () => {
    document.querySelectorAll(".sticky_pro_page, sticky-atc-bar").forEach(el => el.remove());
  };

  name.addEventListener("input", () => {
    clearError();
    clearInvalid();
    lockUI();
  });

  place.addEventListener("input", () => {
    clearError();
    clearInvalid();
    lockUI();
  });

  date.addEventListener("change", () => {
    clearError();
    clearInvalid();
    lockUI();
  });

  date.addEventListener("input", () => {
    clearError();
    clearInvalid();
    lockUI();
  });

  if (time) {
    time.addEventListener("input", () => {
      formatTimeInput();
      clearError();
      clearInvalid();
      lockUI();
    });

    time.addEventListener("change", () => {
      clearError();
      clearInvalid();
      lockUI();
    });
  }

  if (notes) {
    notes.addEventListener("input", () => {
      clearError();
      lockUI();
    });
  }

  if (unk) {
    unk.addEventListener("change", () => {
      syncUnknownTime();
      clearError();
      clearInvalid();
      lockUI();
    });
    syncUnknownTime();
  }

  document.addEventListener("DOMContentLoaded", killSticky);
  window.addEventListener("load", killSticky);

  const obs = new MutationObserver(() => {
    killSticky();
    bindGuards();
    lockUI();
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });

  killSticky();
  bindGuards();
  lockUI();
})();